import { injectable, inject } from 'inversify';
import { TYPES, type IHttpService } from '../app/modules/http';

@injectable()
export class UserPreferencesPersistenceApi {
  private readonly _http: IHttpService;

  public constructor(@inject(TYPES.HttpService) http: IHttpService) {
    this._http = http;
  }

  private _getUrl(surgeryType: string): string {
    const urlPrefix = 'userPreferences/';

    return `${urlPrefix}${surgeryType}`;
  }

  public save<T>(surgeryType: string, jsonContent: T): void {
    this._http
      .put(this._getUrl(surgeryType), jsonContent)
      .then(() => {
        console.info('saved to database');
      })
      .catch((err) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        console.error(`failed to save: ${err.message}`);
      });
  }

  public async get<T>(surgeryType: string): Promise<T> {
    const res = await this._http.get(this._getUrl(surgeryType));
    return res.data as T;
  }
}
